import { IniFile as File } from './file';

export default {
  File,
};
